<template>
<li id="first-item">
    <a id="href-venue" href="/venues/"><i class="fa fa-fw fa-lg fa-map-marker"></i>Venues &nbsp;
        <span class="badge badge-new-bookings" data-toggle="tooltip" data-placement="right" title="Has 1 new booking">1</span>
    </a>
    <div class="grid-container3 submenu hidden-xs">
        <div class="grid-column grid-column3">
            <ul>
                <li><a>Mario</a></li>
                <li><a>Luigi</a></li>
                <li>
                    <a href="/venues/' . $venueId . '/calendar/">John venue
                        <i class="fa fa-indicator fa-chevron-right" style="font-size: 12px; margin: 0 0 0 5px;"></i>
                    </a> <!-- if is master, if not remove the icon -->
                    <div class="grid-container3">
                        <ul>
                            <li><a href="/venues/calendar/">Segment name is here</a></li>
                            <li><a href="/venues/calendar/">Segment name is here</a></li>
                            <li><a href="/venues/calendar/">Segment name is here</a></li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
        <div class="grid-column grid-column3">
            <ul></ul>
        </div>
    </div>
</li>
</template>

<script>
export default {
    //
}
</script>
